module.exports = __webpack_public_path__ + "img/zhihi1.bd4571a4.png";